import RestApiCall from "interceptor/aeh";
import Environment from "services/environment";

const env = Environment.getEnv();

export const checkSession = () => {
    let apiPayload = {
        method: "GET",
        url: "user/v1/check/session",
        baseURL: env.profileBaseUrl,
        config: {
            ignoreRedirection: true,
            ignoreError: true,
            ignoreBusinessError: true,
        },
    };
    return RestApiCall.api(apiPayload);
};

export const fetchUserProfile = () => {
    let apiPayload = {
        method: "GET",
        url: "user/profile/v2/fetch/user/profile",
        baseURL: env.profileBaseUrl,
        config: { ivUser: env.ivUser },
    };
    return RestApiCall.api(apiPayload);
};

export const downloadPicture = (payload) => {
    const apiPayload = {
        method: "POST",
        url: "user/profile/download/picture",
        baseURL: env.profileBaseUrl,
        data: payload,
    }
    return RestApiCall.api(apiPayload);
};
